module.exports = __webpack_public_path__ + "img/vehicleCircleTram.54c78ae7.svg";